import { supabase } from '../lib/supabase';

export const stripeService = {
  async createPaymentIntent(orderData) {
    try {
      const { data, error } = await supabase?.functions?.invoke('create-food-payment', {
        body: {
          orderData
        }
      });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error creating payment intent:', error);
      throw error;
    }
  },

  async confirmPayment(paymentIntentId, orderId) {
    try {
      const { data, error } = await supabase?.functions?.invoke('confirm-food-payment', {
        body: {
          paymentIntentId,
          orderId
        }
      });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error confirming payment:', error);
      throw error;
    }
  },

  formatAmount(amount, currency = 'EUR') {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: currency,
    })?.format(amount);
  }
};